export default `
precision highp float;

attribute vec2 aVertexPosition;
attribute vec2 uv;
attribute vec3 normal;

//Pixi provided
uniform mat3 translationMatrix;
uniform mat3 projectionMatrix;

uniform vec2 lightPos;

varying vec2 vUv;
varying mat3 vNormalMatrix;
//varying vec3 vLightDirection;
varying vec3 vWorldPosition;

void main() {
	vUv = uv;
	vNormalMatrix = translationMatrix;

	//get just the rotational part. 
	//TODO: This probably won't handle non-uniform rotation correctly,
	//the correct way to do it involves taking the transpose of things see:
	//https://www.lighthouse3d.com/tutorials/glsl-12-tutorial/the-normal-matrix/ and
	//https://learnopengl.com/Advanced-Lighting/Normal-Mapping
	vNormalMatrix[2][0] = 0.0;
	vNormalMatrix[2][1] = 0.0;
	vNormalMatrix[2][2] = 1.0;
	// vNormalMatrix[1][2] = 0.0;
	// vNormalMatrix[2][2] = 0.0;

	vWorldPosition = vec3((translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0);
	
	gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
}
`
